import { ASSETS } from "@/lib/assets";
import { useI18n } from "@/lib/i18n";
import { SECTIONS } from "@/constants/testIds";

export default function Process() {
  const { t } = useI18n();
  const items = [
    { img: ASSETS.barrelsCellar, ...t.process.step1 },
    { img: ASSETS.cratesBottles, ...t.process.step2 },
    { img: ASSETS.corks, ...t.process.step3 },
  ];
  return (
    <section
      data-testid={SECTIONS.process}
      className="relative bg-[#070707] text-white py-28 lg:py-40 border-t border-white/5"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#c5a572]" />
              <span className="text-[11px] tracking-[0.42em] text-[#c5a572] uppercase">
                {t.process.eyebrow}
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[56px] leading-[1.05] tracking-tight">
              {t.process.title}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <p className="text-white/60 leading-relaxed font-light">{t.process.body}</p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {items.map((it, i) => (
            <div key={i} className="group relative">
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#0d0d0d]">
                <img
                  src={it.img}
                  alt={it.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute top-5 left-5 font-mono text-[11px] tracking-[0.32em] text-[#c5a572]/90">
                  0{i + 1}
                </div>
                <div className="absolute bottom-0 inset-x-0 p-6">
                  <h3 className="font-serif text-2xl text-white">{it.title}</h3>
                  <p className="mt-2 text-white/65 text-sm font-light max-w-xs">{it.body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
